'use client';

import { useState, useEffect } from 'react';
import posthog from 'posthog-js';

/**
 * Shared hook for AI assistant feature gating.
 * Checks env var override first, then PostHog feature flag.
 * Safe to call even if PostHog is not initialized.
 */
export function useAiAssistantEnabled(): boolean {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    // Env var override — bypass PostHog entirely (for local dev)
    if (process.env.NEXT_PUBLIC_ENABLE_AI_ASSISTANT === 'true') {
      setIsEnabled(true);
      return;
    }

    // Guard: if PostHog was never initialized, flags will never load
    if (!posthog.__loaded) return;

    // Check synchronously in case flags are already loaded
    if (posthog.isFeatureEnabled('enable_ai_assistant')) {
      setIsEnabled(true);
    }

    // Listen for flags to load asynchronously
    posthog.onFeatureFlags(() => {
      setIsEnabled(posthog.isFeatureEnabled('enable_ai_assistant') === true);
    });
  }, []);

  return isEnabled;
}
